/**  */
const componentParams = (string) => {
	const result = {
		success: null,
		error:   null
	};

	if (typeof string === 'string') {
		const normalized = string.replace(/'/g, '"');

		try {
			result.success = JSON.parse(normalized);
		}
		catch (e) {
			result.error = {
				message: `Проблема при парсингу json-масива`,
				e
			};
		}
	}
	else {
		result.error = {
			message: `Неочікуваний тип вхідних даних: очікую "string", передано "${typeof string}"`
		};
	}

	return result;
};

/**  */
const staticParams = string => {
	const result = {
		success: null,
		error:   null
	};

	if (typeof string === 'string') {
		const normalized = string.replace(/'/g, '"');

		try {
			result.success = JSON.parse(normalized);
		}
		catch (e) {
			result.error = {
				message: `Проблема при парсингу json-масива`,
				e
			};
		}
	}
	else {
		result.error = {
			message: `Неочікуваний тип вхідних даних: очікую "string", передано "${typeof string}"`
		};
	}
	return result;
};

export default { componentParams, staticParams };
